/**
 * Pantalla: Llicencies
 * Component: PantLlic.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per generar al fitxa urbanística
 */

import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton, Tooltip, Typography, TextField, Button } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import OlLayerImage from 'ol/layer/Image';
import OlImageSource from 'ol/source/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import LlicState from '../states/LlicState';
import RefCadAdrWidget from '../controls/RefCadAdrWidget';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import MyCustomControl from '../controls/MyCustomControl';
import HorizontalCollapse from '../controls/HorizontalCollapse';
import { IFincaNumero, IRefCad } from '../interfaces/IRefCadAdr';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/Llic.css';
import { EnvironmentOutlined, CameraOutlined } from '@ant-design/icons'
import { ExpandMore, ArrowBackIos, ArrowForwardIos, Link, GpsFixed, Portrait, HomeWorkOutlined, Map, FilterList} from '@material-ui/icons';
import { ILayer, ILayerGroup } from '../interfaces/ILayer';
import { AppDrawer, AppToolBar, AppToolBarElements } from 'ajt-app';
import Util from '../config/util';
import CotaIcon from '@material-ui/icons/SettingsEthernet';
import AreaIcon from '@material-ui/icons/AspectRatio';

@inject('appState')
@observer
export default class PantLlic extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mpState - Els paràmetres el processem dins de createMap de LlicState
        this.llState = new LlicState(this.props);
        // Events pel canvi de mida de la pantalla
        this.llState.updateWindowSize();
        this.autoSize = true;
    }
 
    // El estat del mapa
    private llState: LlicState;
 
    // Diu si agafem les mides de la pantalla
    private autoSize = false;
    private readonly resizeHandler = this.updateDimensions.bind(this);

    updateDimensions() {
        if (this.autoSize) {
            this.llState.updateWindowSize();
        }
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.resizeHandler);
        }
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
    
    // Hem canviat de BaseLayer
    private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
       this.llState.actBaseLayer = layerSelected;
       // La capa de noms només la volem activa als layers de Planejament i Ortofoto
        if (this.llState.nomsLayer) {
            const id: string = layerSelected.get('id');
            const ld: ILayer = this.llState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
            if (ld && ld.noms) {
               this.llState.nomsLayer.set('visible', this.llState.nomsVisible);
               this.llState.setShowNoms(true);
            } else {
               this.llState.nomsLayer.set('visible', false);
               this.llState.setShowNoms(false);
            }
        }
    }
 
    // Hem triat una finca o una adreça del control de text
    private handleOnChange = (e?: IFincaNumero) => {
        if (e) {
            if (e.NUMCOD) {
                this.llState.setFIDFromNumCod(e.NUMCOD);
                this.llState.setHCExpanded(false);
            } else if (e.FINCOD) {
                this.llState.setFIDFromFinCod(e.FINCOD);
                this.llState.setHCExpanded(false);
            } else if (e.FINREFCAD1 && e.FINREFCAD2) {
                this.llState.setFIDFromRefCad(e.FINREFCAD1, e.FINREFCAD2);
                this.llState.setHCExpanded(false);
            } else if (e.COORD && e.COORD.length === 2) {
                this.llState.setIdentMode(1);
                this.llState.setFIDFromPos(e.COORD);
                this.llState.setHCExpanded(false);
            } else {
                this.llState.setFIDFromNumCod(0);
            }
        } else {
            this.llState.setFIDFromNumCod(0);
        }
    }
 
    // Anar a la posició actual del mòbil
    private handleGotoMyLocation = () => {
        this.llState.setActualLocation();
    }

    // Començar a buscar una posició
    private handleMyShowPhoto = () => {
        this.llState.setIdentPosition(2);
    }

    // Començar a buscar una posició (parcel·la)
    private handleMySetPosition = () => {
        this.llState.setIdentMode(1);
        this.llState.setIdentPosition(1);
    }

    // Per posar l'estat del HorizontalCollapse
    private handleHCToggle = () => {
        this.llState.setHCExpanded(!this.llState.hcExpanded);
    }
 
    // Activem o desactivem la capa de noms
    private handleCBNomsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.nomsLayer.setVisible(event.target.checked);
        this.llState.setNomsVisible(event.target.checked);
    };

    // Activem o desactivem la capa de texts d'edificació
    private handleCBTxConsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.txconsLayer.setVisible(event.target.checked);
        this.llState.setTxConsVisible(event.target.checked);
    };

    // Activem o desactivem una capa de referència
    private handleCBRefLayerChange = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const i = this.llState.getRefLayerIndex(id);
        if (i >= 0) {
            this.llState.refLayers[i].setVisible(event.target.checked);
            this.llState.setRefLayerVisible(i, event.target.checked, false);
        }
    }

    // Rederitza un Layer o un LayerGroup
    private renderLayerComponent = (ly: ILayer | ILayerGroup, mrg?: number) => {
        mrg = (mrg ? mrg : 0);
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (rll.legend && rll.legend.length > 0) {
                return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.llState.actRefLayers[this.llState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                    <AccordionDetails style={{display: 'grid', padding: '0px 16px 0px 16px', minHeight: 20}} key={'acd' + rll.id}>
                        {rll.legend.map((lg) => { return (<FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: 10}} 
                            key={'fclg' + lg.name}
                            control={<>{!!lg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + lg.icon} alt={lg.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{lg.name}</Typography>} 
                        />); })}
                    </AccordionDetails>
                </Accordion>);
            } else {
                return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} expanded={false} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                        <FormControlLabel 
                            style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                            key={'fcl' + rll.id}
                            control={<><Checkbox 
                                key={'cb' + rll.id}
                                checked={this.llState.actRefLayers[this.llState.getRefLayerIndex(rll.id)]} 
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)} 
                                name={rll.id}
                                style={{padding: 0}}  
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16}/>&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>} 
                        />
                    </AccordionSummary>
                </Accordion>);
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            return (<Accordion square elevation={0} style={{padding: 0, left: mrg, minHeight: 20}} key={'ac' + rlg.id} defaultExpanded={rlg.expanded}>
                <AccordionSummary key={'gr' + rlg.id} expandIcon={<ExpandMore />} style={{height: 32, maxHeight: 32, minHeight: 20}}>
                    {!!rlg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rlg.icon} alt={rlg.name} width={16} height={16}/>&nbsp;</>}
                    <Typography variant="body2">{rlg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display: 'grid', padding: 0, minHeight: 20}} key={'acd' + rlg.id}>
                    {rlg.layers.map((rl) => { return this.renderLayerComponent(rl, mrg + 10); })}
                </AccordionDetails>
            </Accordion>);
        } else {
            return null;
        }
    }

    // Retrona el nom del layer si està actiu. si és un grup retorna els noms dels layers actius de dins del grup
    private getActiveLayer = (ly: ILayer | ILayerGroup): string => {
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (this.llState.actRefLayers[this.llState.getRefLayerIndex(rll.id)]) {
                return rll.layers;
            }
        } else if (ly.type === 'grp') {
            const rlg = ly as ILayerGroup;
            const lys: Array<string> = rlg.layers.map((rl) => { return this.getActiveLayer(rl); });
            if (lys.length > 0) {
                let slys: string = lys.join(',');
                let slys2: string = Util.replaceAll(slys, ',,', ',');
                while (slys !== slys2) {
                    slys = slys2;
                    slys2 = Util.replaceAll(slys, ',,', ',');
                }
                if (slys.endsWith(',')) {
                    slys = slys.substring(0, slys.length - 1);
                }
                return slys;
            }
        }
        return '';
    }

    private handlePhotoClose = () => {
        this.llState.photoIndex = -1;
        this.llState.photoArray = [];
        this.llState.photoAdr = '';
    }

    private handlePhotoBack = () => {
        let i = this.llState.photoIndex - 1;
        if (i < 0) {
            i = this.llState.photoArray.length - 1;
        }
        this.llState.photoIndex = i;
    }

    private handlePhotoFordward = () => {
        let i = this.llState.photoIndex + 1;
        if (i >=  this.llState.photoArray.length) {
            i = 0;
        }
        this.llState.photoIndex = i;
    }

    /** Dibuixem mesures
     * @param measureType Tipus de mesura
     */
    private handleMeasureMenuItemClick = (measureType: string) => {
        this.llState.setMapInteraction(measureType);
    };

    private handleFilterProcChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.setFilterProc(event.target.value);
    }

    private handleFilterAnyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.setFilterAny(event.target.value);
    }

    private handleFilterObertsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.setFilterOberts(event.target.checked);
    }

    private handleFilterTancatsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.llState.setFilterTancats(event.target.checked);
    }

    private handleFilterApl = () => {
        this.llState.setqSelect(this.llState.getLlicParms().qfilter);
        this.llState.pllicLayer.getSource().refresh();
    }

    // Mostra un diàleg amb l'enllaç
    private handleGetLink = () => {
        // Posar un popup amb el link
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname;
        // BaseLayer
        const id: string = this.llState.actBaseLayer.get('id');
        const ld: ILayer = this.llState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
        url += '?Base=' + ld.layers;
        // RefLayers
        const lys: Array<string> = this.llState.mapConfig.refLayers.map((rl) => {
            return this.getActiveLayer(rl);
        })
        if (lys.length > 0) {
            let slys: string = lys.join(',');
            let slys2: string = Util.replaceAll(slys, ',,', ',');
            while (slys !== slys2) {
                slys = slys2;
                slys2 = Util.replaceAll(slys, ',,', ',');
            }
            if (slys.endsWith(',')) {
                slys = slys.substring(0, slys.length - 1);
            }
            if (slys.startsWith(',')) {
                slys = slys.substring(1);
            }
            if (slys) {
                url+= '&Layers=' + slys;
            }
        }

        // Referència cadastral o posició
        if (this.llState.finCod) {
            if (!this.llState.finRefCad1 || !this.llState.finRefCad2) {
                this.llState.refCadWebApi.getRefCad(this.llState.finCod).then((resultrc: IRefCad) => {
                    this.llState.finRefCad1 = resultrc.FINREFCAD1;
                    this.llState.finRefCad2 = resultrc.FINREFCAD2;
                    url += '&RefCad=' + this.llState.finRefCad1 + this.llState.finRefCad2;
                    this.props.appState.dialState.messageBox({    
                        title: 'Enllaç',
                        message: url,
                        buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
                    }).then((result) => {
                        if (result === 'Copiar URL') {
                            navigator.clipboard.writeText(url);
                            this.props.appState.notiState.showMessage('URL copiada');
                        }
                    });
                }).catch(() => { / * No fa res * / }); 
            } else {
                url += '&RefCad=' + this.llState.finRefCad1 + this.llState.finRefCad2;
                this.props.appState.dialState.messageBox({    
                    title: 'Enllaç',
                    message: url,
                    buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
                }).then((result) => {
                    if (result === 'Copiar URL') {
                        navigator.clipboard.writeText(url);
                        this.props.appState.notiState.showMessage('URL copiada');
                    }
                });
            }    
        } else {
            // Centre del mapa i Zoom
            const c = this.llState.olview.getCenter();
            url += '&Pos=' + c[0].toFixed(2) + ';' + c[1].toFixed(2) + ';' + this.llState.olview.getZoom().toFixed(0);
            this.props.appState.dialState.messageBox({    
                title: 'Enllaç',
                message: url,
                buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
            }).then((result) => {
                if (result === 'Copiar URL') {
                    navigator.clipboard.writeText(url);
                    this.props.appState.notiState.showMessage('URL copiada');
                }
            });
        }
    }

    // Salta a la pantalla de la fitxa urbanística
    private handleShowFU = () => {
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname.replace('llicencies', 'fitxurb');
        window.open(url + "?RefPar=" + this.llState.finRefCad1 + this.llState.finRefCad2);
    }

    // Salta a la pantalla de propietaris i habitants
    private handleShowHab = () => {
        window.open(this.llState.mapConfig.habUrl + "?RefPar=" + this.llState.finRefCad1 + this.llState.finRefCad2);
    }

    // Slata a la pantalla del banc de dades
    private handleShowBBDD = () => {
        window.open(this.llState.mapConfig.bbddUrl + "?Conn=AJT.INF&Ref1=" + this.llState.finRefCad1 + "&Ref2=" + this.llState.finRefCad2);
    }

    render () {
        if (!this.llState.configOk) {
            return null;
        }

        const w: number = this.llState.width; // Amplada de la finestra
        const drw: number = this.props.appState.menuState.marginDrawer; // Amplada el drawer
        const wx: string = (w - drw).toString() + 'px'; // Amplada del mapa

        const mto: string = w < 601 ? (w < 600 ? '96px' : '112px') : '112px'; // Posició top del mapa
        const h: number = this.llState.height - 106 + (w < 601 ? (w < 600 ? 16 : 8) : 0); // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        const lx: string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        const bx: string = 'calc(100% - ' + (h + ( w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        const txr = w < 601 ? (w < 600 ? '106px' : '122px') : '122px'; // Top del cercador
        const lxr: string = w < 601 ? '2.5em' : 'calc(50% - ' + ((w / 2) - 300) + 'px)'; // Esquerra del cercador
        const wxr = (w - (w < 601 ? 45 : 310)).toString() + 'px'; // Amplada del crecador quan està desplegat

        const thc = w < 601 ? (w < 600 ? '106px' : '122px') : '122px';  // Posició (superior) del control de capa de noms
        const rhc = 'calc(100% - ' + (w + 5).toString() + 'px)'; // Posició (dreta) del control de capa de noms

        const thc2 = this.llState.showNoms ? (w < 601 ? (w < 600 ? '148px' : '164px') : '164px') : thc; // Posició (superior) del control de capa de texts d'edificació

        return (
            <>
                <AppToolBar style={{zIndex: 1300}} showHelp={true}>
                    <AppToolBarElements alignment='left'>
                        {this.llState.mapConfig.measureTool && <Tooltip title="Mesurar longitud">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'l')} key="mdistance">
                                <CotaIcon />
                            </IconButton>
                        </Tooltip>}
                        {this.llState.mapConfig.measureTool && <Tooltip title="Mesurar àrea">
                            <IconButton onClick={this.handleMeasureMenuItemClick.bind(this, 'a')} key="marea">
                                <AreaIcon />
                            </IconButton>
                        </Tooltip>}
                        <Tooltip title="Fitxa urbanística">
                            <IconButton onClick={this.handleShowFU} key="ibfu" disabled={!this.llState.finCod}>
                                <Map />
                            </IconButton>
                        </Tooltip>
                        {`${this.props.appState.entorn}` !== 'internet' && this.llState.mapConfig.habUrl && <Tooltip title="Propietaris i habitants">
                            <IconButton onClick={this.handleShowHab} key="ibhab" disabled={!this.llState.finCod}>
                                <Portrait />
                            </IconButton>
                        </Tooltip>}
                        {`${this.props.appState.entorn}` !== 'internet' && this.llState.mapConfig.bbddUrl && <Tooltip title="Banc de dades">
                            <IconButton onClick={this.handleShowBBDD} key="ibbbdd" disabled={!this.llState.finCod}>
                                <HomeWorkOutlined />
                            </IconButton>
                        </Tooltip>}
                    </AppToolBarElements>
                    <AppToolBarElements alignment='right'>
                        <Tooltip title="Enllaçar">
                            <IconButton onClick={this.handleGetLink} key="iblink">
                                <Link />
                            </IconButton>
                        </Tooltip>
                    </AppToolBarElements>
                </AppToolBar>
                <AppDrawer variant={ w < 601 ? 'temporary' : 'permanent'}>
                    <Accordion square elevation={0} style={{padding: 0, left: 0, minHeight: 20}} key={'afltr'} expanded={true}>
                        <AccordionSummary key={'asfltr'} /* expandIcon={<ExpandMore />} */ style={{height: 32, maxHeight: 32, minHeight: 20}}>
                            <FormControlLabel 
                                style={{fontSize: '12px', padding: 0, marginLeft: -6}} 
                                key={'fclfltr'}
                                control={<FilterList />}
                                label={<Typography variant="body2">FILTRE</Typography>} 
                            />
                        </AccordionSummary>
                        <AccordionDetails style={{display: 'grid', padding: '0px 16px 0px 16px', minHeight: 20}} key={'acdfltr'}>
                            <TextField
                                key={'txprocfltr'}
                                fullWidth={true} 
                                variant='outlined'
                                size='small'
                                label={"Tipus d'expedients"}
                                value={this.llState.filterProc}
                                onChange={this.handleFilterProcChange.bind(this)}
                                title="Llista de procediments separats per comes (LLI.OMA, LLI.COM) o LLI.*"
                                required={true}
                            />
                            <br />
                            <TextField 
                                key={'txanyfltr'}
                                fullWidth={true} 
                                variant='outlined'
                                size='small'
                                label={"Any de registre"}
                                value={this.llState.filterAny}                               
                                onChange={this.handleFilterAnyChange.bind(this)}
                                title="Un any, interval d'anys o anys separats per comes (2022, 2024-2025)"
                                required={true}
                            />
                            <br />
                            <span>
                                <Checkbox 
                                    key={'cbobfilter'}
                                    checked={this.llState.filterOberts} 
                                    onChange={this.handleFilterObertsChange.bind(this)} 
                                    name={"Oberts"}
                                    style={{padding: 0}}  
                                />Oberts
                                &nbsp;&nbsp;
                                <Checkbox 
                                    key={'cbtafilter'}
                                    checked={this.llState.filterTancats} 
                                    onChange={this.handleFilterTancatsChange.bind(this)} 
                                    name={"Oberts"}
                                    style={{padding: 0}}  
                                />Tancats
                            </span>
                            <br />
                            <Button
                                key={'btnfltr'}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={this.handleFilterApl}  
                            >Aplicar</Button>
                        </AccordionDetails>
                    </Accordion>
                    <hr />
                    {
                        this.llState.mapConfig.refLayers.map((rl) => {
                            return this.renderLayerComponent(rl);
                        })
                    }
                </AppDrawer>
                <>
                    {this.llState.refCadWebApi && <HorizontalCollapse
                        style={{zIndex: 2, backgroundColor: 'rgba(250, 250, 250, 0.8)', position: 'absolute', left: lxr, top: txr}}
                        expandedWidth={wxr}
                        expanded={this.llState.hcExpanded}
                        onToggleExpanded={this.handleHCToggle}
                        text={'Cercador'}
                    >
                        <RefCadAdrWidget
                            proxyWebApi={this.llState.refCadWebApi}
                            numCod={this.llState.numCod}
                            finCod={this.llState.finCod}
                            // finRefCad1={this.llState.finRefCad1}
                            // finRefCad2={this.llState.finRefCad2}
                            onChange={this.handleOnChange}
                            floatingLabelText="Cercar per adreça o referència cadastral"
                        />
                    </HorizontalCollapse>}
                    {this.llState.olmap && <MapComponent map={this.llState.olmap} style={{width: wx, height: hx, cursor: this.llState.identPosition ? 'crosshair' : this.llState.identElement ? 'pointer' : 'default', position: 'fixed', top: mto}}/>}
                    {this.llState.olmap && <MyZoomToExtent map={this.llState.olmap} tooltip="Zoom total" extent={this.llState.mapConfig.initialExtent}/>}
                    {this.llState.olmap && <MyCustomControl
                        map={this.llState.olmap} 
                        className="my-1-position" 
                        icon={GpsFixed}
                        tooltip="Centrar el mapa a la posició actual"
                        onClick={this.handleGotoMyLocation}
                        key="mycc1"
                    />}
                    {this.llState.olmap && <MyCustomControl
                        map={this.llState.olmap} 
                        className="my-2-position" 
                        icon={EnvironmentOutlined}
                        tooltip="Identificar una parcel·la"
                        onClick={this.handleMySetPosition}
                        key="mycc2"
                    />}
                    {this.llState.olmap && <MyCustomControl
                        map={this.llState.olmap} 
                        className="my-3-position" 
                        icon={CameraOutlined}
                        tooltip="Mostrar la fotografia de la façana"
                        onClick={this.handleMyShowPhoto}
                        key="mycc4"
                    />}
                    {this.llState.baseLayers.length === 2 && <MyLayerSwitcher
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2
                        }}
                        map={this.llState.olmap}
                        layers={this.llState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls1"
                    />}
                    {this.llState.baseLayers.length > 2 && <MyLayerSwitcher2 
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2,
                            backgroundColor: 'rgba(250, 250, 250, 0.8)'
                        }}
                        map={this.llState.olmap}
                        layers={this.llState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls2"
                    />}
                    {this.llState.showNoms && <FormControlLabel 
                        style={{zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc, width: '160px'}}
                        control={<Checkbox 
                            checked={this.llState.nomsVisible} 
                            onChange={this.handleCBNomsChange} 
                            name="cbNoms"   
                        />}
                        label={<Typography variant="body2">{this.llState.nomsLayer.get('name')}</Typography>} 
                        title='Activar o desactivar la capa de noms de carrers i de números postals'
                    />}
                    {this.llState.showTxCons && <FormControlLabel 
                        style={{zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc2, width: '160px'}}
                        control={<Checkbox 
                            checked={this.llState.txConsVisible} 
                            onChange={this.handleCBTxConsChange} 
                            name="cbTxCons"   
                        />}
                        label={<Typography variant="body2">{this.llState.txconsLayer.get('name')}</Typography>} 
                        title={'Activar o desactivar la capa de texts d\'edificació'}
                    />}
                    {this.llState.photoIndex >= 0 && <Dialog 
                        onClose={this.handlePhotoClose}
                        open={this.llState.photoIndex >= 0}
                    >
                        <DialogTitle disableTypography style={{padding: '0px 0px 0px 24px'}}>
                            <span className={'pllic-popup-content'}><b>{this.llState.photoAdr}</b></span>
                            <div className={'pllic-popup-closer'} onClick={this.handlePhotoClose} />
                        </DialogTitle>
                        <DialogContent>
                            <img style={{maxWidth: '500px', maxHeight: '400px'}} src={this.llState.mapConfig.wsPhoto + '?Photo=' + this.llState.photoArray[this.llState.photoIndex] + '&Usuari=' + this.llState.usr + '&Session=' + this.llState.ses} />
                            {this.llState.photoArray.length > 1 && <>
                                <IconButton onClick={this.handlePhotoBack} style={{float: 'left', position: 'absolute', left: '10px', top: '50%'}} key="ib1">
                                    <ArrowBackIos />
                                </IconButton>
                                <IconButton onClick={this.handlePhotoFordward} style={{float: 'right', position: 'absolute', right: '10px', top: '50%'}} key="ib2">
                                    <ArrowForwardIos />
                                </IconButton>
                            </>}
                        </DialogContent>
                    </Dialog>}
                </>
            </>
        );
    }
}